import { ReactNode, useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { WootingCDN } from "../../utils/constants/openGraph";
import {
  Card,
  CardContent,
  CardHeader,
  Flex,
  Heading,
  VStack,
} from "@wootingkb/component-library";

const SLIDES = [
  { src: WootingCDN.login.lekkerEdition, alt: "keyboard" },
  { src: WootingCDN.login.wristrest, alt: "wristrest" },
  { src: WootingCDN.login.wootingTwoHe, alt: "keyboard" },
] as const;

const SLIDE_INTERVAL_MS = 5000;
const FADE_DURATION_S = 0.75;

export default function LoginContainer({
  children,
  type,
}: {
  children: ReactNode;
  type: ReactNode;
}) {
  return (
    <Flex className="h-full w-full items-center justify-center gap-4 lg:flex-row">
      <Slideshow />
      <DefaultInputs type={type}>{children}</DefaultInputs>
    </Flex>
  );
}

function Slideshow() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setIndex((i) => (i + 1) % SLIDES.length),
      SLIDE_INTERVAL_MS
    );
    return () => clearInterval(id);
  }, []);

  const slide = SLIDES[index];

  return (
    <VStack
      alignment="centered"
      className="relative h-fit min-h-48 w-full overflow-hidden lg:h-full"
    >
      <div className="relative h-fit w-full lg:h-full">
        <div className="grid w-full place-items-center p-8 *:col-start-1 *:row-start-1 lg:absolute lg:inset-0">
          <AnimatePresence initial={false}>
            <motion.div
              key={slide.src}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: FADE_DURATION_S, ease: "easeInOut" }}
              className="flex items-center justify-center"
            >
              <img
                src={slide.src}
                alt={slide.alt}
                className="h-auto max-w-full object-contain"
              />
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </VStack>
  );
}

function DefaultInputs({
  children,
  type,
}: {
  children: ReactNode;
  type: ReactNode;
}) {
  return (
    <Card className="w-full lg:w-1/2">
      <CardHeader>
        <Heading as="h3" size="h4" weight="semibold" className="capitalize">
          {type}
        </Heading>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
